import { useSyncExternalStore } from "react";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

// Optional-chained for jsdom, where matchMedia may be absent.
function getMediaQueryList(): MediaQueryList | null {
  return window.matchMedia?.(REDUCED_MOTION_QUERY) ?? null;
}

function subscribe(listener: () => void): () => void {
  const mediaQueryList = getMediaQueryList();
  mediaQueryList?.addEventListener?.("change", listener);
  return () => mediaQueryList?.removeEventListener?.("change", listener);
}

function getSnapshot(): boolean {
  return getMediaQueryList()?.matches ?? false;
}

/** True while the OS asks for reduced motion; updates live when the setting changes. */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
